var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGoogleCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 14.276C25.9999 13.4603 25.9325 12.6402 25.7885 11.8378H14.2417V16.4586H20.854C20.5796 17.9489 19.698 19.2672 18.407 20.105V23.1032H22.3519C24.6685 21.0133 25.9999 17.9268 25.9999 14.276Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2415 26C17.5432 26 20.3276 24.9374 22.3562 23.1032L18.4113 20.1049C17.3138 20.8368 15.8969 21.2513 14.246 21.2513C11.0523 21.2513 8.34445 19.1393 7.37284 16.2998H3.302V19.3906C5.38016 23.4427 9.61293 26 14.2415 26V26Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36856 16.2997C6.85577 14.8094 6.85577 13.1956 7.36856 11.7053V8.6145H3.30222C1.56593 12.0052 1.56593 15.9999 3.30222 19.3905L7.36856 16.2997V16.2997Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2415 6.74949C15.9868 6.72303 17.6736 7.36677 18.9376 8.54843L22.4327 5.1225C20.2196 3.08547 17.2823 1.96554 14.2415 2.00081C9.61293 2.00081 5.38016 4.55813 3.302 8.61457L7.36835 11.7054C8.33545 8.86148 11.0478 6.74949 14.2415 6.74949V6.74949Z",
    fill: "#EA4335"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-circle.e972ca23.svg";
export { ForwardRef as ReactComponent };